export const site = {
  name: '反差现场',
  slogan: '台上台下，一镜到底',
  description:
    '反差现场是一个聚焦网红台前幕后反差的中文内容站，把直播录制、台下偶遇、粉丝爆料与私下被拍的现场素材集中呈现，用镜头前后的对比还原真实状态。',
  email: 'contact@contrast-scene.media',
  nav: [
    { label: '首页', path: '/' },
    { label: '反差档案', path: '/category/live' },
    { label: '关于我们', path: '/about' },
  ],
};

export type Stat = { value: string; label: string; note: string };

export const stats: Stat[] = [
  { value: '482', label: '已归档反差案例', note: '覆盖直播、线下与社交场景' },
  { value: '97%', label: '素材保留完整语境', note: '拒绝断章取义与拼接剪辑' },
  { value: '4', label: '内容栏目', note: '直播 / 偶遇 / 爆料 / 被拍' },
  { value: '每周', label: '固定更新节奏', note: '均衡覆盖四大方向' },
];

export type Testimonial = { name: string; role: string; text: string };

export const testimonials: Testimonial[] = [
  {
    name: '林*舟',
    role: '内容从业者',
    text: '终于有人不把反差写成"塌房合集"了。这里更像是把现场摊开给你看，结论留给读者，这一点很难得。',
  },
  {
    name: '阿*',
    role: '长期读者',
    text: '我最喜欢"台下偶遇实录"这个栏目，里面有不少让人对一个人改观的瞬间，看完不会觉得在消费别人。',
  },
  {
    name: 'C*r',
    role: '社群管理员',
    text: '对比模块做得很清楚，台上和台下两段话放一起，很多东西不用解释就能看懂。',
  },
  {
    name: '小*',
    role: '普通观众',
    text: '排版干净，没有被标题党绑架。晚上睡前看两篇，比刷短视频舒服多了。',
  },
];

export type Principle = { icon: string; title: string; desc: string };

export const principles: Principle[] = [
  {
    icon: 'ri-file-list-3-line',
    title: '保留完整语境',
    desc: '不做掐头去尾的拼接，素材的时间、地点与前后情境尽量交代清楚，让读者看到过程而不是结论。',
  },
  {
    icon: 'ri-shield-keyhole-line',
    title: '守住隐私边界',
    desc: '只收录与公开言行相关的信息，私人住所、联系方式、家庭成员与未成年人内容一律不呈现。',
  },
  {
    icon: 'ri-scales-3-line',
    title: '双边呈现',
    desc: '台上与台下并列展示，正反面素材同等对待，避免把内容做成单向的道德审判。',
  },
  {
    icon: 'ri-quill-pen-line',
    title: '冷静表达',
    desc: '用观察代替情绪，用事实代替形容词。我们不做标题党，也不替读者下判断。',
  },
];